export const ARROWS_INCREMENT = 1
export const ANIMATION_DURATION = 0.5
export const INERTIA = 10
